module.exports = __webpack_public_path__ + "static/media/arrowRight.f63d437a.svg";